import { CTA } from "components";
import { useStoryblokLink } from "hooks";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { CTASAdapterProps } from "./CTA.d";

const CTASAdapter = ({
  blok: { heading, buttonText, checkmarks, link, gtmSection, gtmElement, gaLabel, gaPlacement },
  sbEditable,
}: ReactStoryblokComponent<CTASAdapterProps>) => {
  const checkboxes = checkmarks.length > 0 ? checkmarks.map(({ text }) => text) : undefined;
  const resolvedButtonHref = useStoryblokLink(link);

  return (
    <CTA
      text={heading}
      buttonText={buttonText}
      checkboxes={checkboxes}
      buttonHref={resolvedButtonHref}
      gtmSection={gtmSection}
      gtmElement={gtmElement}
      gaLabel={gaLabel}
      gaPlacement={gaPlacement}
      sbEditable={sbEditable}
    />
  );
};

export default CTASAdapter;
